export default __webpack_public_path__ + "static/media/video-manual.14005866.svg";